'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var Vue = _interopDefault(require('vue'));

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

var clickOutside = {
  bind (el, binding) {
    const handler = (e) => {
      if (!el.contains(e.target) && el !== e.target) {
        binding.value(e);
      }
    };
    el.__vueClickOutside__ = handler;

    document.addEventListener('click', handler);
  },

  unbind (el) {
    document.removeEventListener('click', el.__vueClickOutside__);
    el.__vueClickOutside__ = null;
  }
};

var normalizeString = function (value) {
    if (!value)
        return '';
    return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};
function getWords(query) {
    if (!query)
        return '';
    return query.trim().split(' ');
}
function findBy(xs, query, key) {
    if (xs === void 0) { xs = []; }
    if (query === void 0) { query = ''; }
    if (key === void 0) { key = ''; }
    var words = getWords(query);
    return xs.filter(function (option) { return normalizeString(option[key]).includes(query); });
}

function bindEvent (el, event, callback, ...options) {
  el.addEventListener(event, callback, ...options);

  return () => el.removeEventListener(event, callback, ...options)
}

function normalizeDiacritics(value) {
    if (!value)
        return '';
    return value
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
}

function setDiacritic(xs, normalizeProp, searchProp) {
    return xs.map(function (item) {
        var _a;
        return (__assign(__assign({}, item), (_a = {}, _a[normalizeProp] = normalizeDiacritics(item[searchProp]), _a)));
    });
}

function getMatches(word, words) {
    if (word === void 0) { word = ''; }
    if (words === void 0) { words = ''; }
    var normalizedWord = normalizeDiacritics(word);
    var normalizedWords = normalizeDiacritics(words);
    return normalizedWords.toLowerCase().split(normalizedWord.toLowerCase());
}

function getRemaining(word, words) {
    var matches = getMatches(word, words);
    var atBeginning = !(matches[0] || []).length;
    var remaining = (matches.filter(Boolean)[0] || []).length;
    return {
        atBeginning: atBeginning,
        remaining: atBeginning ? remaining * -1 : remaining
    };
}

function getDiacritic(obj, key, word, words) {
    var _a = getRemaining(word, words), atBeginning = _a.atBeginning, remaining = _a.remaining;
    var untilEnd = remaining + word.length;
    if (word === words)
        return obj[key];
    return atBeginning
        ? obj[key].slice(0, remaining)
        : obj[key].slice(remaining, untilEnd);
}

var script = Vue.extend({
    name: 'item',
    props: {
        searchProp: String,
        normalizeProp: String,
        item: {
            type: Object,
            required: true
        },
        index: Number,
        pointer: Number,
        search: String
    },
    computed: {
        chunks: function () {
            var typed = getDiacritic(this.item, this.searchProp, normalizeDiacritics(this.search), this.item[this.normalizeProp]);
            var chunks = this.item[this.searchProp]
                .split(typed)
                .reduce(function (chunks, split, i, splits) {
                var hasAfter = !!splits[i + 1];
                var hasBefore = !!splits[i - 1];
                var splitChunk = { content: split, bold: true };
                var typedChunk = { content: typed, bold: false };
                var initialChunks = !split ? __spreadArrays(chunks, [typedChunk]) : __spreadArrays(chunks);
                var preChunks = (!split && !hasBefore && !hasAfter)
                    ? [typedChunk]
                    : initialChunks;
                return __spreadArrays(preChunks, [
                    splitChunk,
                    split && hasAfter ? typedChunk : {}
                ]);
            }, []);
            return chunks;
        }
    }
});

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      class: ["vue-coemplete-item", { "-active": _vm.index === _vm.pointer }],
      on: {
        click: function($event) {
          return _vm.$emit("item-list:click")
        },
        mouseenter: function($event) {
          if ($event.target !== $event.currentTarget) {
            return null
          }
          return _vm.$emit("item-list:mouseenter", _vm.index)
        }
      }
    },
    [
      _vm._t("sufix", null, { item: _vm.item }),
      _vm._v(" "),
      _c(
        "span",
        { ref: _vm.index, staticClass: "text" },
        _vm._l(_vm.chunks, function(chunk, key) {
          return _c(chunk.bold ? "b" : "span", { key: key, tag: "component" }, [
            _vm._v(_vm._s(chunk.content))
          ])
        }),
        1
      ),
      _vm._v(" "),
      _vm._t("after", null, { item: _vm.item })
    ],
    2
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-3cffc5bb_0", { source: ".vue-coemplete-item {\n  opacity: 0.8;\n  color: #121E48;\n  padding: 0 15px;\n  font-size: 14px;\n  line-height: 40px;\n  cursor: pointer;\n  overflow-x: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.vue-coemplete-item.-active {\n  background-color: rgba(18, 30, 72, 0.05);\n}\n\n/*# sourceMappingURL=Item.vue.map */", map: {"version":3,"sources":["/Users/convenia/Desktop/convenia-spa/vue-coemplete/src/components/Item.vue","Item.vue"],"names":[],"mappings":"AAkFA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EAEA,eAAA;EAEA,kBAAA;EACA,mBAAA;EACA,uBAAA;ACnFA;ADqFA;EAAA,wCAAA;AClFA;;AAEA,mCAAmC","file":"Item.vue","sourcesContent":["<template>\n  <div\n    :class=\"['vue-coemplete-item', { '-active': index === pointer }]\"\n\n    @click=\"$emit('item-list:click')\"\n    @mouseenter.self=\"$emit('item-list:mouseenter', index)\"\n  >\n    <slot name=\"sufix\" :item=\"item\" />\n\n    <span :ref=\"index\" class=\"text\">\n      <component\n        v-for=\"(chunk, key) in chunks\"\n        :key=\"key\"\n        :is=\"chunk.bold ? 'b' : 'span'\"\n      >{{ chunk.content }}</component>\n    </span>\n\n    <slot name=\"after\" :item=\"item\" />\n  </div>\n</template>\n\n<script lang=\"ts\">\nimport getDiacritic from '../utils/getDiacritic'\nimport normalizeDiacritics from '../utils/normalizeDiacritics'\n\nimport Vue from 'vue'\n\ninterface Chunk {\n  content: string,\n  bold: boolean,\n}\n\nexport default Vue.extend({\n  name: 'item',\n\n  props: {\n    searchProp: String,\n\n    normalizeProp: String,\n\n    item: {\n      type: Object,\n      required: true\n    },\n\n    index: Number,\n\n    pointer: Number,\n\n    search: String\n  },\n\n  computed: {\n    chunks () : Chunk[] {\n      const typed = getDiacritic(this.item, this.searchProp, normalizeDiacritics(this.search), this.item[this.normalizeProp])\n\n      const chunks = this.item[this.searchProp]\n        .split(typed)\n        .reduce((chunks: Chunk[], split: string, i: number, splits: string[]) => {\n          const hasAfter: Boolean = !!splits[i + 1]\n          const hasBefore: Boolean = !!splits[i - 1]\n          const splitChunk = { content: split, bold: true }\n          const typedChunk = { content: typed, bold: false }\n          const initialChunks = !split ? [ ...chunks, typedChunk ] : [ ...chunks ]\n          const preChunks = (!split && !hasBefore && !hasAfter)\n            ? [ typedChunk ]\n            : initialChunks\n\n          return [\n            ...preChunks,\n            splitChunk,\n            split && hasAfter ? typedChunk : {}\n          ]\n        }, [])\n\n      return chunks\n    }\n  }\n})\n</script>\n\n<style lang=\"scss\">\n.vue-coemplete-item {\n  opacity: 0.8;\n  color: #121E48;\n  padding: 0 15px;\n  font-size: 14px;\n  line-height: 40px;\n\n  cursor: pointer;\n\n  overflow-x: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n\n  &.-active { background-color: rgba(18, 30, 72, 0.05); }\n}\n</style>\n",".vue-coemplete-item {\n  opacity: 0.8;\n  color: #121E48;\n  padding: 0 15px;\n  font-size: 14px;\n  line-height: 40px;\n  cursor: pointer;\n  overflow-x: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.vue-coemplete-item.-active {\n  background-color: rgba(18, 30, 72, 0.05);\n}\n\n/*# sourceMappingURL=Item.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

var script$1 = Vue.extend({
    components: { Item: __vue_component__ },
    props: {
        items: {
            type: Array,
            required: true
        },
        pointer: Number
    }
});

/* script */
const __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "list-wrapper" }, [
    _c(
      "div",
      { staticClass: "list" },
      _vm._l(_vm.items, function(item, index) {
        return _c(
          "item",
          _vm._g(
            _vm._b(
              {
                key: index,
                attrs: { item: item, index: index, pointer: _vm.pointer },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "before",
                      fn: function(ref) {
                        var item = ref.item;
                        return _vm._t("before", null, { item: item })
                      }
                    },
                    {
                      key: "after",
                      fn: function(ref) {
                        var item = ref.item;
                        return _vm._t("after", null, { item: item })
                      }
                    }
                  ],
                  null,
                  true
                )
              },
              "item",
              _vm.$attrs,
              false
            ),
            _vm.$listeners
          )
        )
      }),
      1
    )
  ])
};
var __vue_staticRenderFns__$1 = [];
__vue_render__$1._withStripped = true;

  /* style */
  const __vue_inject_styles__$1 = function (inject) {
    if (!inject) return
    inject("data-v-17a0cfb9_0", { source: ".list-wrapper {\n  display: flex;\n  position: absolute;\n  left: 0;\n  top: 100%;\n  width: 100%;\n  z-index: 10;\n  background: white;\n  border-radius: 0 0 5px 5px;\n  box-shadow: 0 2px 6px -2px rgba(0, 0, 0, 0.2);\n  max-height: calc(285px - 40px);\n}\n.list-wrapper > .list {\n  width: 100%;\n  font-size: 14px;\n  overflow-y: auto;\n}\n\n/*# sourceMappingURL=ItemList.vue.map */", map: {"version":3,"sources":["/Users/convenia/Desktop/convenia-spa/vue-coemplete/src/components/ItemList.vue","ItemList.vue"],"names":[],"mappings":"AAwCA;EACA,aAAA;EAEA,kBAAA;EACA,OAAA;EACA,SAAA;EAEA,WAAA;EACA,WAAA;EACA,iBAAA;EACA,0BAAA;EACA,6CAAA;EACA,8BAAA;ACzCA;AD2CA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;ACzCA;;AAEA,uCAAuC","file":"ItemList.vue","sourcesContent":["<template>\n  <div class=\"list-wrapper\">\n    <div class=\"list\">\n      <item\n        v-for=\"(item, index) in items\"\n\n        :key=\"index\"\n        :item=\"item\"\n        :index=\"index\"\n        :pointer=\"pointer\"\n\n        v-bind=\"$attrs\"\n        v-on=\"$listeners\"\n      >\n        <slot slot=\"before\" name=\"before\" slot-scope=\"{ item }\" :item=\"item\" />\n        <slot slot=\"after\" name=\"after\" slot-scope=\"{ item }\" :item=\"item\" />\n      </item>\n    </div>\n  </div>\n</template>\n\n<script lang=\"ts\">\nimport Vue from 'vue'\nimport Item from './Item.vue'\n\nexport default Vue.extend({\n  components: { Item },\n\n  props: {\n    items: {\n      type: Array,\n      required: true\n    },\n\n    pointer: Number\n  }\n})\n</script>\n\n<style lang=\"scss\">\n.list-wrapper {\n  display: flex;\n\n  position: absolute;\n  left: 0;\n  top: 100%;\n\n  width: 100%;\n  z-index: 10;\n  background: white;\n  border-radius: 0 0 5px 5px;\n  box-shadow: 0 2px 6px -2px rgba(0, 0, 0, 0.2);\n  max-height: calc(285px - 40px); // 40 = input size\n\n  & > .list {\n    width: 100%;\n    font-size: 14px;\n    overflow-y: auto;\n  }\n}\n</style>",".list-wrapper {\n  display: flex;\n  position: absolute;\n  left: 0;\n  top: 100%;\n  width: 100%;\n  z-index: 10;\n  background: white;\n  border-radius: 0 0 5px 5px;\n  box-shadow: 0 2px 6px -2px rgba(0, 0, 0, 0.2);\n  max-height: calc(285px - 40px);\n}\n.list-wrapper > .list {\n  width: 100%;\n  font-size: 14px;\n  overflow-y: auto;\n}\n\n/*# sourceMappingURL=ItemList.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$1 = undefined;
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1 = normalizeComponent(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    false,
    createInjector,
    undefined,
    undefined
  );

var script$2 = Vue.extend({
    name: 'vue-coemplete',
    components: { ItemList: __vue_component__$1 },
    props: {
        value: String,
        placeholder: String,
        options: {
            type: Array,
            default: function () { return []; }
        },
        searchProp: {
            type: String,
            default: 'key'
        },
        normalizeProp: {
            type: String,
            default: 'normalized'
        },
        minToSearch: {
            type: Number,
            default: 2
        },
        showList: Boolean
    },
    directives: { clickOutside: clickOutside },
    data: function () {
        return {
            search: '',
            pointer: -1,
            showItems: false
        };
    },
    watch: {
        value: {
            immediate: true,
            handler: function (value) { this.search = value; }
        },
        search: {
            immediate: true,
            handler: function () { this.$emit('vue-coemplete:items', this.__items); }
        }
    },
    mounted: function () {
        bindEvent(document, 'visibilitychange', this.onVisibilityChange);
    },
    computed: {
        styles: function () {
            var border = {
                'border-radius': this.isOpened
                    ? '20px 20px 0 0'
                    : '20px'
            };
            return __assign({}, border);
        },
        classes: function () {
            return ['vue-coemplete', {
                    '--is-opened': this.isOpened,
                    '--is-closed': !this.showItems,
                    '--has-shadow': this.hasShadow
                }];
        },
        hasSlots: function () {
            return !!Object.keys(this.$scopedSlots).length;
        },
        hasShadow: function () {
            return this.showItems && !this.__items.length;
        },
        isOpened: function () {
            return this.showItems && this.__items.length;
        },
        __items: function () {
            if (!this.search || this.search.length <= this.minToSearch)
                return [];
            var query = normalizeDiacritics(this.search);
            var xs = setDiacritic(this.options, this.normalizeProp, this.searchProp);
            return findBy(xs, query, this.normalizeProp);
        }
    },
    methods: {
        reset: function () {
            this.showItems = false;
            this.pointer = -1; // reset pointer
        },
        down: function () {
            if (this.pointer < this.__items.length - 1)
                this.pointer++;
        },
        up: function () {
            if (this.pointer > 0)
                this.pointer--;
        },
        select: function (_a) {
            var key = (_a === void 0 ? 'Enter' : _a).key;
            if (key !== 'Enter' && key !== 'Click')
                return;
            var item = this.__items[this.pointer];
            this.$nextTick(this.reset);
            if (!this.hasSlots) {
                var value = item[this.searchProp];
                this.search = value;
                this.onSearch(value);
            }
            this.$emit('vue-coemplete:select', item);
        },
        onSearch: function (value) {
            this.search = value;
            this.showItems = true;
        },
        onVisibilityChange: function () {
            var action = document.visibilityState === 'visible' ? 'focus' : 'unfocus';
            this.$emit("vue-coemplete:" + action);
            if (!this.$refs.input)
                return;
            this.$refs.input.focus();
        }
    }
});

/* script */
const __vue_script__$2 = script$2;

/* template */
var __vue_render__$2 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.reset,
          expression: "reset"
        }
      ],
      class: _vm.classes,
      style: _vm.styles,
      on: {
        keyup: function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          ) {
            return null
          }
          return _vm.reset($event)
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "search-wrapper",
          on: {
            click: function($event) {
              _vm.showItems = !_vm.showItems;
            }
          }
        },
        [
          _vm._t(
            "input",
            [
              _c("input", {
                ref: "input",
                staticClass: "input",
                domProps: { value: _vm.search },
                on: {
                  keydown: [
                    function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "up", 38, $event.key, [
                          "Up",
                          "ArrowUp"
                        ])
                      ) {
                        return null
                      }
                      $event.preventDefault();
                      return _vm.up($event)
                    },
                    function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "down", 40, $event.key, [
                          "Down",
                          "ArrowDown"
                        ])
                      ) {
                        return null
                      }
                      $event.preventDefault();
                      return _vm.down($event)
                    },
                    function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k(
                          $event.keyCode,
                          "enter",
                          13,
                          $event.key,
                          "Enter"
                        ) &&
                        _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                      ) {
                        return null
                      }
                      $event.stopPropagation();
                      if ($event.target !== $event.currentTarget) {
                        return null
                      }
                      return _vm.select($event)
                    }
                  ],
                  input: function(event) {
                    return _vm.onSearch(event.target.value)
                  }
                }
              })
            ],
            {
              onSearch: _vm.onSearch,
              keyboardEvents: { up: _vm.up, down: _vm.down, select: _vm.select }
            }
          )
        ],
        2
      ),
      _vm._v(" "),
      _c("item-list", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isOpened || _vm.showList,
            expression: "isOpened || showList"
          }
        ],
        attrs: {
          items: _vm.__items,
          search: _vm.search,
          pointer: _vm.pointer,
          "search-prop": _vm.searchProp,
          "normalize-prop": _vm.normalizeProp
        },
        on: {
          "item-list:click": function($event) {
            return _vm.select({ key: "Click" })
          },
          "item-list:mouseenter": function(index) {
            return (_vm.pointer = index)
          },
          "vue-coemplete-mouseenter": function(index) {
            return (_vm.pointer = index)
          }
        },
        scopedSlots: _vm._u(
          [
            {
              key: "before",
              fn: function(ref) {
                var item = ref.item;
                return _vm._t("before", null, { item: item })
              }
            },
            {
              key: "after",
              fn: function(ref) {
                var item = ref.item;
                return _vm._t("after", null, { item: item })
              }
            }
          ],
          null,
          true
        )
      })
    ],
    1
  )
};
var __vue_staticRenderFns__$2 = [];
__vue_render__$2._withStripped = true;

  /* style */
  const __vue_inject_styles__$2 = function (inject) {
    if (!inject) return
    inject("data-v-37cff6ef_0", { source: ".vue-coemplete {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  background: white;\n}\n.vue-coemplete > .search-wrapper {\n  display: flex;\n  min-height: 40px;\n  position: relative;\n}\n.vue-coemplete > .search-wrapper > .input {\n  flex: 1;\n  outline: 0;\n  width: 100%;\n  border: none;\n  height: 40px;\n  font-size: 14px;\n  padding-left: 15px;\n  border-radius: 20px;\n  padding-right: 40px;\n  color: rgba(18, 30, 72, 0.8);\n  background: rgba(18, 30, 72, 0.05);\n}\n\n/*# sourceMappingURL=VueCoemplete.vue.map */", map: {"version":3,"sources":["/Users/convenia/Desktop/convenia-spa/vue-coemplete/src/VueCoemplete.vue","VueCoemplete.vue"],"names":[],"mappings":"AAmNA;EACA,aAAA;EACA,sBAAA;EAEA,kBAAA;EAEA,iBAAA;ACpNA;ADsNA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;ACpNA;ADsNA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,4BAAA;EACA,kCAAA;ACpNA;;AAEA,2CAA2C","file":"VueCoemplete.vue","sourcesContent":["<template>\n  <div\n    :style=\"styles\"\n    :class=\"classes\"\n\n    v-click-outside=\"reset\"\n\n    @keyup.esc=\"reset\"\n  >\n    <div class=\"search-wrapper\" @click=\"showItems = !showItems\">\n      <slot\n        name=\"input\"\n        :on-search=\"onSearch\"\n        :keyboard-events=\"{ up, down, select }\">\n\n        <input\n          ref=\"input\"\n          class=\"input\"\n\n          :value=\"search\"\n\n          @keydown.up.prevent=\"up\"\n          @keydown.down.prevent=\"down\"\n          @keydown.enter.tab.stop.self=\"select\"\n\n          @input=\"event => onSearch(event.target.value)\"\n        />\n      </slot>\n    </div>\n\n    <item-list\n      v-show=\"isOpened || showList\"\n\n      :items=\"__items\"\n      :search=\"search\"\n      :pointer=\"pointer\"\n      :search-prop=\"searchProp\"\n      :normalize-prop=\"normalizeProp\"\n\n      @item-list:click=\"select({ key: 'Click' })\"\n      @item-list:mouseenter=\"index => pointer = index\"\n      @vue-coemplete-mouseenter=\"index => pointer = index\"\n    >\n      <slot slot=\"before\" name=\"before\" slot-scope=\"{ item }\" :item=\"item\" />\n      <slot slot=\"after\" name=\"after\" slot-scope=\"{ item }\" :item=\"item\" />\n    </item-list>\n  </div>\n</template>\n\n<script lang=\"ts\">\nimport Vue from 'vue'\n\nimport clickOutside from './clickOutside'\n\nimport findBy from './utils/findBy'\nimport bindEvent from './utils/bindEvent'\nimport setDiacritic from './utils/setDiacritic'\nimport normalizeDiacritics from './utils/normalizeDiacritics'\n\nimport ItemList from './components/ItemList.vue'\n\nexport default Vue.extend({\n  name: 'vue-coemplete',\n\n  components: { ItemList },\n\n  props: {\n    value: String,\n\n    placeholder: String,\n\n    options: {\n      type: Array,\n      default: () => []\n    },\n\n    searchProp: {\n      type: String,\n      default: 'key'\n    },\n\n    normalizeProp: {\n      type: String,\n      default: 'normalized'\n    },\n\n    minToSearch: {\n      type: Number,\n      default: 2\n    },\n\n    showList: Boolean\n  },\n\n  directives: { clickOutside },\n\n  data () {\n    return {\n      search: '' as string,\n      pointer: -1 as number,\n      showItems: false as boolean\n    }\n  },\n\n  watch: {\n    value: {\n      immediate: true,\n      handler (value) { this.search = value }\n    },\n\n    search: {\n      immediate: true,\n      handler () { this.$emit('vue-coemplete:items', this.__items) }\n    }\n  },\n\n  mounted () {\n    bindEvent(document, 'visibilitychange', this.onVisibilityChange)\n  },\n\n  computed: {\n    styles (): object {\n      const border = {\n        'border-radius': this.isOpened\n          ? '20px 20px 0 0'\n          : '20px'\n      }\n\n      return { ...border }\n    },\n\n    classes () {\n      return ['vue-coemplete', {\n        '--is-opened': this.isOpened,\n        '--is-closed': !this.showItems,\n        '--has-shadow': this.hasShadow\n      }]\n    },\n\n    hasSlots (): boolean {\n      return !!Object.keys(this.$scopedSlots).length\n    },\n\n    hasShadow () {\n      return this.showItems && !this.__items.length\n    },\n\n    isOpened (): boolean {\n      return this.showItems && this.__items.length\n    },\n\n    __items (): object[] {\n      if (!this.search || this.search.length <= this.minToSearch) return []\n\n      const query: string = normalizeDiacritics(this.search)\n      const xs: object[] = setDiacritic(this.options, this.normalizeProp, this.searchProp)\n\n      return findBy(xs, query, this.normalizeProp)\n    }\n  },\n\n  methods: {\n    reset () {\n      this.showItems = false\n      this.pointer = -1 // reset pointer\n    },\n\n    down () {\n      if (this.pointer < this.__items.length - 1) this.pointer++\n    },\n\n    up () {\n      if (this.pointer > 0) this.pointer--\n    },\n\n    select ({ key } = 'Enter'): void {\n      if (key !== 'Enter' && key !== 'Click') return\n\n      const item = this.__items[this.pointer]\n\n      this.$nextTick(this.reset)\n\n      if (!this.hasSlots) {\n        const value = item[this.searchProp]\n\n        this.search = value\n        this.onSearch(value)\n      }\n\n      this.$emit('vue-coemplete:select', item)\n    },\n\n    onSearch (value: string): void {\n      this.search = value\n      this.showItems = true\n    },\n\n    onVisibilityChange (): void {\n      const action = document.visibilityState === 'visible' ? 'focus' : 'unfocus'\n\n      this.$emit(`vue-coemplete:${action}`)\n\n      if (!this.$refs.input) return\n\n      this.$refs.input.focus()\n    }\n  }\n})\n</script>\n\n<style lang=\"scss\">\n.vue-coemplete {\n  display: flex;\n  flex-direction: column;\n\n  position: relative;\n\n  background: white;\n\n  & > .search-wrapper {\n    display: flex;\n    min-height: 40px;\n    position: relative;\n\n    & > .input {\n      flex: 1;\n      outline: 0;\n      width: 100%;\n      border: none;\n      height: 40px;\n      font-size: 14px;\n      padding-left: 15px;\n      border-radius: 20px;\n      padding-right: 40px;\n      color: rgba(18, 30, 72, 0.8);\n      background: rgba(18, 30, 72, 0.05);\n    }\n  }\n}\n</style>\n",".vue-coemplete {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  background: white;\n}\n.vue-coemplete > .search-wrapper {\n  display: flex;\n  min-height: 40px;\n  position: relative;\n}\n.vue-coemplete > .search-wrapper > .input {\n  flex: 1;\n  outline: 0;\n  width: 100%;\n  border: none;\n  height: 40px;\n  font-size: 14px;\n  padding-left: 15px;\n  border-radius: 20px;\n  padding-right: 40px;\n  color: rgba(18, 30, 72, 0.8);\n  background: rgba(18, 30, 72, 0.05);\n}\n\n/*# sourceMappingURL=VueCoemplete.vue.map */"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$2 = undefined;
  /* module identifier */
  const __vue_module_identifier__$2 = undefined;
  /* functional template */
  const __vue_is_functional_template__$2 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$2 = normalizeComponent(
    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    false,
    createInjector,
    undefined,
    undefined
  );

exports.VueCoemplete = __vue_component__$2;
